<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="1100px">
    <div class="personnel">
      <el-table :data="tableData" ref="table"
                :row-style="{height: '0'}"
                style="width: 100%" height="400">
        <el-table-column v-show="false" prop="id" label="ID" ></el-table-column>
        <el-table-column prop="account_code" label="科目代码" ></el-table-column>
        <el-table-column prop="account_name" label="科目名称" ></el-table-column>
        <el-table-column prop="allow_reimburse" label="可报销金额" ></el-table-column>
        <el-table-column label="报销金额" >
          <template slot-scope="scope">
            <el-input v-model="scope.row.amount" size="mini" @change="changeData(scope)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="备注" >
          <template slot-scope="scope">
            <el-input v-model="scope.row.use_detail" size="mini"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="personnel-footer">
      <el-button size="mini" type="info" @click="closeFun">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirmFun">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>
import Http from "../../common/Http";

export default {
  name: "TravelReimbursement",
  data(){
    return {
      dialogVisible:false,
      tableData: [],
      selectData: [],
      departmentId: 0 ,
      year: 0,
      type: null,
      callback_fun:null,
    }
  },
  mounted() {

  },
  methods:{
    initConfig(){
      this.callback_fun = undefined;
    },
    show(config, callback_fun){
      const that = this;
      that.initConfig();
      that.dialogVisible=true;
      if(typeof callback_fun==="function"){
        that.callback_fun=callback_fun;
      }
      that.type = config.type;
      that.departmentId = config.department_id;
      that.year = config.year;
      that.getList();
    },
    getList(){
      const that = this;
      let where = {
        type: that.type,
        departmentId: that.departmentId,
        year: that.year
      };
      Http.get("https://budget.gdzawy.com:9001/admin/budgetSendApi/sendTripEepenseApply",where,res=>{
        if(res.code) {
          for (let i = 0; i < res.data.length; i++) {
            let item = res.data[i];
            item.amount = '';
            item.use_detail = '';
          }
          that.tableData = res.data;
        } else {
          that.tableData = [];
        }
      })
    },
    changeData(item) {
      if (/^-?\d+(\.\d+)?$/.test(item.row.amount) ==  false) {
        this.tableData[item.$index]['amount'] = 0
        this.$message.error("请输入数字！")
        return false
      }
      let amount = parseFloat(item.row.amount)
      let allow_reimburse = parseFloat(item.row.allow_reimburse)
      if (amount < 0) {
        this.tableData[item.$index]['amount'] = 0
        this.$message.error("报销金额不能小于0！")
        return false
      }
      if (amount > allow_reimburse) {
        //this.tableData[item.$index]['amount'] = 0
        //this.$message.error("报销金额不能大于可报销金额！")
        //return false
      }
    },
    closeFun() {
      this.dialogVisible=false;
    },
    confirmFun() {
      if(typeof this.callback_fun ==="function"){
        this.callback_fun(this.tableData);
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    }

  }
}
</script>

<style lang="scss" scoped>
.personnel{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .personnel-left{
    width: 300px;
    height: 50vh;
    //overflow-y: scroll;

    .user_role_body{
      height: 50vh;
      overflow-y: scroll;
      .user_role_body_item{
        color: #6f7175;
        width: 100%;
        cursor: pointer;
        padding: 2px 0 2px 5px;
        margin: 2px 0;
        &:hover{
          background-color: #e8e8e8;
        }
        &:active{
          background-color: #b2c7d0;
        }
        &.active{
          background-color: #b2c7d0;
        }
      }
    }
    .history_user_body{
      height: 50vh;
      overflow-y: scroll;
      .history_user_body_item{
        color: #6f7175;
        width: 100%;
        cursor: pointer;
        padding: 2px 0 2px 5px;
        margin: 2px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:hover{
          background-color: #e8e8e8;
        }
        &:active{
          background-color: #b2c7d0;
        }
        &.active{
          background-color: #b2c7d0;
        }
      }
    }
  }
  .personnel-right{
    width: 600px;
    margin-left: 5px;
    height: 100%;
  }
  .personnel-right-select{
    width: 150px;
    .personnel-right-select-view{
      height: 50vh;
      overflow-y: scroll;
    }
  }
}
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/plug/TravelReimbursement.vue